import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

// Section 12 — implementation and support. No fixed timelines promised.
export const PulseImplementation = ({ sp }) => (
  <section aria-labelledby="pulse-implementation-heading" data-testid="pulse-implementation" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="12"
        eyebrow="Implementation & Support"
        title="Configured around how your business operates"
        description={sp.implementationCopy}
        testid="pulse-implementation-header"
      />
      <ol className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {(sp.stages || []).map((stage, i) => (
          <Reveal key={stage.title} delay={i * 0.08} className="h-full">
            <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-white p-6" data-testid={`pulse-stage-${i + 1}`}>
              <span className="font-mono text-sm font-bold tracking-widest text-gold-700">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="mt-3 text-lg font-extrabold tracking-tight text-navy-900">{stage.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{stage.text}</p>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
